import { Component } from 'vue-property-decorator';
import BpcDocumentTable from '@tools/components/tables/document-table/document-table.vue';
import Vue from 'vue';

@Component({
  name: 'bpc-document',
  components: {
    'bpc-document-table': BpcDocumentTable,
  },
})
export default class Document extends Vue {
  /* Lifecycle hooks */
  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
